module.exports = {
  id: 'newsletterForm',
  method: 'post',
  target: '_blank',
  action: 'https://eu2.cleverreach.com/f/146712-146368/wcs/',
  cells: [
    {
      modifier: 'half',
      fieldType: 'input',
      name: 'vorname',
      label: 'Vorname',
      placeholder: 'Vorname'
    },
    {
      modifier: 'half',
      fieldType: 'input',
      name: 'nachname',
      label: 'Nachname',
      placeholder: 'Nachname'
    },
    {
      fieldType: 'select',
      name: 'sprache',
      label: 'Sprache',
      options: [
        {
          value: 'Deutsch',
          text: 'Deutsch'
        },
        {
          value: 'Englisch',
          text: 'Englisch'
        }
      ],
      required: true
    },
    {
      fieldType: 'input',
      name: 'email',
      type: 'email',
      label: 'E-Mail',
      placeholder: 'E-Mail',
      required: true
    }
  ],
  submitText: 'Anmelden'
};
